export default __webpack_public_path__ + "static/media/nkrumah-borninme.37132da4.png";